var SDK_VERSION = '7.60.1';
export { SDK_VERSION };